// Fills every server-rendered title-sponsor shell on the page with its logo + link.
//
// Who the title sponsor (冠協賛) is lives in the admin booth registry, like every
// other sponsor logo: the booth dashboard sets ロゴ掲出レベル = 冠協賛 (+ an optional
// 対象ページ for a registry shared by several header identities). The API
// resolves that per identity, so this script just takes the `title` rows. The
// `event` metaobject only decides the hero presentation — the label text and
// whether/where the badge shows. Shells are rendered by sections/event-header
// and blocks/title-sponsor:
//
//   <div data-title-sponsor data-api-base data-event-id data-identity
//        data-link-class data-image-class>
//     <span data-title-sponsor-slot></span>   ← replaced by each title sponsor's
//   </div>                                       <a><img></a> / <img> (or name)
//
// fetchPublicSponsors is memoised per (apiBase, eventId, identity), so the hero,
// the 協賛 strip and the footer pyramid share one request. A shell with no title
// sponsor in the roster is hidden.
import { fetchPublicSponsors } from '@fujigravel/api-contract';

for (const shell of document.querySelectorAll('[data-title-sponsor]')) {
  fill(shell);
}

async function fill(shell) {
  const { apiBase, eventId, identity, linkClass, imageClass } = shell.dataset;
  const slot = shell.querySelector('[data-title-sponsor-slot]');
  if (!slot || !apiBase || !eventId) return;

  let titles = [];
  try {
    const { sponsors } = await fetchPublicSponsors(apiBase, eventId, { identity });
    titles = sponsors.filter((s) => s.level === 'title');
  } catch (err) {
    console.error('[title-sponsor] fetch failed', err);
  }
  if (titles.length === 0) {
    shell.hidden = true;
    return;
  }

  slot.replaceWith(...titles.map((sponsor) => renderLogo(sponsor, linkClass, imageClass)));
}

function renderLogo(sponsor, linkClass, imageClass) {
  const name = sponsor.listed_name || sponsor.exhibitor_name || '';
  let logo;
  if (sponsor.logo_url) {
    logo = document.createElement('img');
    logo.src = sponsor.logo_url;
    logo.alt = name;
    logo.decoding = 'async';
  } else {
    // No logo yet: the display name in the same badge box.
    logo = document.createElement('span');
    logo.textContent = name;
    logo.dataset.textLogo = '';
  }
  logo.className = imageClass || '';

  if (!sponsor.website) return logo;
  const link = document.createElement('a');
  link.href = sponsor.website;
  link.target = '_blank';
  link.rel = 'noopener';
  link.className = linkClass || '';
  link.appendChild(logo);
  return link;
}
